import { metricsApi } from '../api/metricsApi';
import { SSO_ACCOUNT_URI, SSO_URI, LANDING_PAGE_BASE_URL } from '../config';
import { requestProductToken, requestUserInfo } from '../api/authApi';

export const STORAGE_ITEM_PRODUCT_TOKEN = 'sso_productToken';

export const storeTokenInBrowser = productToken => {
    sessionStorage.setItem(STORAGE_ITEM_PRODUCT_TOKEN, productToken);
};

export const getTokenFromBrowser = () => {
    const productToken = sessionStorage.getItem(STORAGE_ITEM_PRODUCT_TOKEN);

    if (productToken) {
        return productToken;
    }
    return null;
};

export const removeTokenFromBrowser = () => {
    sessionStorage.removeItem(STORAGE_ITEM_PRODUCT_TOKEN);
};

export const redirectToLogin = async () => {
    await metricsApi.counterMetric(
        'authorize_redirect_total',
        {},
        'authorize redirect'
    );
    const loginUrl = `${SSO_URI}/view/login?product=itv7&url=${LANDING_PAGE_BASE_URL}&redirectPath=/`;
    window.location.replace(loginUrl);
};

export const redirectToAccount = () => {
    const accountUrl = `${SSO_ACCOUNT_URI}/account/navigation?product=itv7&prod=117&url=${LANDING_PAGE_BASE_URL}&redirectPath=/`;
    window.location.replace(accountUrl);
};

export const getProductToken = async uuid => {
    const response = await requestProductToken(uuid);
    if (response.data) {
        return response.data.productToken;
    }
    return null;
};

export const getUserInfo = async productToken => {
    const response = await requestUserInfo(productToken);
    if (response.data) {
        return response.data;
    }
    return null;
};

export const checkUserLoggedIn = async productToken => {
    const user = await getUserInfo(productToken);
    if (!user) {
        return false;
    }

    return true;
};
